import { mapCollection } from '../../utils/collection.utils';
import { ModelVisualizator as ModelVisualizator } from '../summary/model-visualizator';
import { SummaryBuilder } from './summary.builder';

export class ModelVisualizatorBuilder {

  static modelVisualizatorFromJson(json, diff: number) {
    return (json)
      ? new ModelVisualizator(
        json.modelHash,
        json.modelReference,
        json.modelName,
        SummaryBuilder.modelSummaryStatusFromJson(json.status, diff),
        json.isNotRealPieceTime,
        json.lastPieceTimeBigger,
        json.lastPieceTimeLower
      )
      : null;
  }


  static modelVisualizatorFromList(list, diff: number) {
    const createModelVisualizator = modelVisualizator => ModelVisualizatorBuilder.modelVisualizatorFromJson(modelVisualizator, diff);

    return mapCollection(createModelVisualizator, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/model-visualizator.builder.ts